import * as turf from '@turf/turf'
import { debounce } from '../../../utils/Geotile'

/**
  * Calculating new position of a point, given center of shape and new bearing
  * @param {Object} center geo feature representing center of polygon
  * @param {Number} newBearing degrees from N of new angle
  * @returns {Number[]} [lng, lat] 
*/
function rotatePoint( center, newBearing, originalCoords ) {
  const distanceFromCenter = turf.distance( center, originalCoords )
  const bearingFromCenter = turf.bearing( center, originalCoords )
  const newPoint = turf.destination( center, distanceFromCenter, bearingFromCenter + newBearing )
  return newPoint.geometry.coordinates
}

/**
 * Returns given geoshape rotated to new bearing
 * @param {Object} feature geojson defining shape
 * @param {Number} newBearing how many degrees from N the shape should rotate
 * @returns {Object} geojson new feature
 */
function rotateShape( feature, newBearing ) {
  const center = turf.center( feature )
  const nCoords = feature.geometry.coordinates[0].map( point => rotatePoint( center, newBearing, point ) )
  return {
    ...feature,
    geometry : {
      ...feature.geometry,
      coordinates : [ nCoords ]
    }
  }
}

function init( opts ) {
  const { onDrawUpdate : _onDrawUpdate, getFeature } = opts
  const onDrawUpdate = debounce( _onDrawUpdate, 100 )
  return {

    onSetup( opts ) {
      this.map.dragPan.disable()
      const originalFeature = getFeature()
      const coordinates = originalFeature?.geometry?.coordinates?.[0]
      let state = {}
      if ( coordinates ) {
        state = {
          originalFeature,
          originalCenter : turf.center( originalFeature )
        }
        this.state = state
      }
      this.onKeyDown = evt => this.handleKeyPress( state, evt )
      window.addEventListener( 'keydown', this.onKeyDown )
      return state
    },

    handleKeyPress( state, evt ) {
      const changes = {
        L : 1,
        l : 5,
        K : -1,
        k : -5
      }
      const { originalFeature : feature } = state
      if ( [ 'l', 'k', 'L', 'K' ].includes( evt.key ) ) {
        const bearing = this.bearing || 0
        const nBearing = bearing + changes[evt.key]
        this.bearing = nBearing
        const np = rotateShape( feature, nBearing )
        this._ctx.api.add( np )
        onDrawUpdate( np, { rotation : nBearing } )
      }
    },

    onDrag( state, e ) {
      const { originalFeature : feature, originalCenter : center } = state
      if ( feature ) {
        const newBearing = turf.bearing( center, [ e.lngLat.lng, e.lngLat.lat ] )
        const np = rotateShape( feature, newBearing )
        this._ctx.api.add( np )
        onDrawUpdate( np, { rotation : newBearing } )
      }
    },

    onStop() {
      this.map.dragPan.enable()
      window.removeEventListener( 'keydown', this.onKeyDown )
    },

    toDisplayFeatures( state, geojson, display ) {
      return display( geojson );
    },
  }
}

module.exports = {
  init,
  rotatePoint,
  rotateShape
}
